import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function AdminProtectedRoute({ children }) {
  const location = useLocation();
  
  // Admin token kontrolü
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  
  // Token yoksa login sayfasına yönlendir
  if (!token) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  
  // Rol kontrolünü kaldırdık - sadece token varlığını kontrol ediyoruz
  // Backend'den gelen rol ne olursa olsun kabul ediyoruz

  return children;
}
